import styled from 'styled-components';
import React, {FC, useState, useEffect} from 'react';

import {SocialMediaLink} from '../../socialMedia/widget';
import {Menu} from './menu';
import {Item, OverlayMenu} from './overlayMenu';
import {OverlaySearch} from './overlaySearch';
import {getTopBarHeight} from '../../../molecules/topbarR4';

export interface DynamicFrontPageHeaderProps {
  isSearchPage?: boolean;
  isHighlighted?: boolean;
  locationPath: string;
}

export interface FrontPageHeaderProps extends DynamicFrontPageHeaderProps {
  socialMediaLinks: SocialMediaLink[];
  menuItems: Item[];
  locationPath: string;
  hasSubscriptionForm: boolean;
  onSubscriptionOverlayOpen: () => void;
}

const StyledWrapperOuter = styled.div`
  position: sticky;
  top: -1px;
  left: 0;
  z-index: 3;
`;

export const FrontPageHeader: FC<FrontPageHeaderProps> = props => {
  const [topBarHeight, setTopBarHeight] = useState(0);
  const {
    hasSubscriptionForm,
    onSubscriptionOverlayOpen,
    socialMediaLinks,
    menuItems,
    isSearchPage,
    isHighlighted,
    locationPath
  } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearchOverlay = async () => {
    setTopBarHeight(await getTopBarHeight());
    setIsMenuOpen(false);
    setIsSearchOpen(!isSearchOpen);
    document.body.style.overflow = isSearchOpen ? 'initial' : 'hidden';
  };

  const toggleMenuOverlay = async () => {
    setTopBarHeight(await getTopBarHeight());
    setIsSearchOpen(false);
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? 'initial' : 'hidden';
  };

  useEffect(() => {
    // Page has to be scrollable again if the location changes
    document.body.style.overflow = 'initial';
  }, [locationPath]);

  return (
    <StyledWrapperOuter>
      <Menu
        hasSubscriptionForm={hasSubscriptionForm}
        isSearchPage={isSearchPage || false}
        isHighlighted={isHighlighted || false}
        socialMediaLinks={socialMediaLinks}
        isMenuOpen={isMenuOpen}
        isSearchOpen={isSearchOpen}
        toggleMenuOverlay={toggleMenuOverlay}
        toggleSearchOverlay={toggleSearchOverlay}
        openSubscriptionOverlay={onSubscriptionOverlayOpen}
      />
      <OverlayMenu items={menuItems} isVisible={isMenuOpen} topBarHeight={topBarHeight} />
      <OverlaySearch isVisible={isSearchOpen} topBarHeight={topBarHeight} />
    </StyledWrapperOuter>
  );
};
